/* Init slick carousels / videos for content blocks outside the home + landing views (product, collection). */
(function ($) {
  if (!$) return;
  function sizes() { return (window.ORW && ORW.responsiveSizes) || { phone: 768, tablet: 1024, desktopSmall: 1280 }; }
  function init() {
    var $mods = $('.content-blocks section.carousel');
    if (!$mods.length || !$.fn.slick) return;
    var rs = sizes();
    $mods.each(function () {
      var $c = $(this);
      if ($c.hasClass('slick-initialized')) return;
      var portrait = $c.hasClass('portrait');
      var show = function (x) { return { slidesToShow: x + (portrait ? 1 : (x === 2 ? 0 : -1)) }; };
      var make = function () {
        $c.slick({
          arrows: true, dots: false, infinite: false,
          nextArrow: '<button type="button" data-role="none" aria-label="Next" class="slick-next"></button>',
          prevArrow: '<button type="button" data-role="none" aria-label="Previous" class="slick-prev"></button>',
          slidesToShow: show(4).slidesToShow, speed: 300,
          responsive: [
            { breakpoint: rs.phone, settings: 'unslick' },
            { breakpoint: rs.tablet, settings: show(2) },
            { breakpoint: rs.desktopSmall, settings: show(3) }
          ]
        });
      };
      if (window.innerWidth >= rs.phone) make();
      $c.addClass('show');
    });
  }
  $(init);
})(window.jQuery);
